import { render, staticRenderFns } from "./el-divider.vue?vue&type=template&id=6213ee15"
import script from "./el-divider.vue?vue&type=script&lang=js"
export * from "./el-divider.vue?vue&type=script&lang=js"
import style0 from "./el-divider.vue?vue&type=style&index=0&id=6213ee15&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports